// src/components/store/sections/newsletter/NewsletterV53CathedralinviteSlateGold.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV53CathedralinviteSlateGold(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={53}
      archKey="cathedral_invite"
      archLabel="Cathedral Arch Invite"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
